import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from './authentication/AuthContext';

function Login() {
  const navigate = useNavigate();
  const { setToken } = useAuth(); // Use AuthContext for setting token

  const [loading, setLoading] = useState(false);
  const [badLogin, setBadLogin] = useState(false);
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });

  function logMeIn(event) {
    event.preventDefault();
    setBadLogin(false);

    fetch(`${process.env.REACT_APP_API_URL}/token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: loginForm.email,
        password: loginForm.password,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          setBadLogin(true);
          throw new Error("Invalid credentials");
        }
        return response.json();
      })
      .then((data) => {
        setToken(data.access_token); // Use AuthContext to set token
        setLoading(true);
        navigate('/profile'); // On revient à la page précédente, qui a redirigé vers le login
      })
      .catch((error) => {
        console.error("Login error:", error);
        setBadLogin(true);
      })
      .finally(() => {
        setLoading(false);
        setLoginForm({ email: "", password: "" });
      });
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setLoginForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  }

  return (
    <div className="page-general-container">
      <div className="page-general-background-color"></div>

      <div
        className="page-general-background-hero"
        style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}
      >
        <div
          className="page-general-background-image"
          style={{
            backgroundImage: `url(https://res.cloudinary.com/dc1felxem/image/upload/v1741078754/hydros90_22124_Sustainable_residential_building_with_eco-frie_3ee8dc47-d37f-4df4-96e4-9dafa1286851_3_qlfno0.jpg)`,
          }}
        ></div>
      </div>

      <div className="page-main-content">
        {loading ? (
          <div className="loader-container">
            <img src="./loader.gif" alt="Loading..." className="loader" />
          </div>
        ) : (
          <Fragment>
            <img
              src="/icon/compte-goutte-white-logo.png"
              alt="Logo"
              className="homepage-image"
            />
            <h1 className="login-top-title">Espace animateur</h1>
            <div className="login-container">
              <h1 className="login-title">Connectez-vous</h1>
              <form className="login-form" onSubmit={logMeIn}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={loginForm.email}
                  onChange={handleChange}
                  className="form-input-container"
                  required
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Mot de passe"
                  value={loginForm.password}
                  onChange={handleChange}
                  className="form-input-container"
                  required
                />
                {badLogin && (
                  <div className="bad-login-div">
                    Mot de passe ou email incorrect
                  </div>
                )}
                <button type="submit" className="start-button">
                  Se connecter
                </button>
              </form>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default Login;
